export default {
  en: {
    'containers.filing-entity-header.entity': 'Entity',
    'containers.filing-entity-header.due': 'Due',
    'containers.filing-entity-header.vat': 'VAT number',
  },
};
